import React from "react";
import { Button } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

export const getFormPreviewUrl = (formId, hostname = window.location.hostname) => {
  let previewOrigin;
  if (hostname === "admin.rahebehesht.com") {
    previewOrigin = "https://rahebehesht.com";
  } else if (hostname === "beta.admin.rahebehesht.com") {
    previewOrigin = "https://beta.rahebehesht.com";
  }

  return (
    previewOrigin && formId
      ? `${previewOrigin}/form/${formId}?preview=true`
      : undefined);
};

const FormPreviewButton = ({ formId, variant = "contained", style }) => {
  const previewUrl = getFormPreviewUrl(formId);

  return (
    <Button
      variant={variant}
      color="primary"
      startIcon={<VisibilityIcon />}
      disabled={!previewUrl}
      href={previewUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
    >
      پیش‌نمایش
    </Button>
  );
};

export default FormPreviewButton;
